import { useMutation, useQuery } from '@tanstack/react-query';
import { keys } from '@/api/queryKeys';
import { publicUrgencyApi } from '../api/publicUrgencyApi';

export function usePublicUrgencyGate(token: string | null | undefined) {
  const query = useQuery({
    queryKey: keys.publicUrgency(token ?? ''),
    queryFn: ({ signal }) => publicUrgencyApi.getGate(token!, { signal }),
    enabled: !!token,
    staleTime: 60_000,
  });

  const verifyDob = useMutation({
    mutationFn: (dob: string) => publicUrgencyApi.verifyDob(token!, { dob }),
  });

  return { ...query, verifyDob };
}
